/**
 * Ksting
 *
 * Copyright © 2020 Rana Terning and Pelle Lundgren. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import styles from './title.scss';
import { bool, string } from 'prop-types';
import classNames from 'clsx';
/**
 * This is the Title component.
 *
 * @author Rana Terning & Pelle Lundgren
 */

const Title = props => {
  const {
    title = '',
    small,
    medium,
    large,
    className: customClassName,
  } = props;

  const className = classNames(styles.title, customClassName, {
    [styles.small]: small,
    [styles.medium]: medium,
    [styles.large]: large,
  });

  return (
    <div className={styles.wrapper}>
      <h1 className={className}>{title}</h1>
    </div>
  );
};

/**
 * Declare expected property types.
 *
 * @type {Object}
 */
Title.propTypes = {
  title: string.isRequired,
  small: bool,
  medium: bool,
  large: bool,
  className: string,
};

/**
 * Set default properties.
 *
 * @type {Object}
 */
Title.defaultProps = {
  title: '',
  small: false,
  medium: false,
  large: false,
  className: null,
};

export default Title;
